import script from "./FittersStatisticsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./FittersStatisticsTable.vue?vue&type=script&setup=true&lang=js"

import "./FittersStatisticsTable.vue?vue&type=style&index=0&id=447a6a98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-447a6a98"]])

export default __exports__